import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManageChallengeCategoriesRoutingModule } from './manage-challenge-categories-routing.module';
import { ManageChallengeCategoriesComponent } from './manage-challenge-categories.component';
import { SharedModule } from '../../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';


@NgModule({
  declarations: [ManageChallengeCategoriesComponent],
  imports: [
    CommonModule,
    SharedModule,
    ManageChallengeCategoriesRoutingModule,
    ReactiveFormsModule
  ]
})
export class ManageChallengeCategoriesModule { }
